@if (navigationTree(); as navigationTree) {
    <div class="mobile-group">
        <div class="mobile-group__header" (click)="toggleIsSubGroupOpened()">
            {{ navigationTree.name }}

            <mat-icon class="mobile-group__icon" [class.opened]="false" svgIcon="ico_caret_down" />
        </div>
    </div>
}
